import React from "react"
import { useTranslation } from "react-i18next";
import css from "components/Footer.module.css"
import { useStore } from "store";

function Footer() {
    const { i18n } = useTranslation()
    const t = useStore(state => state.translations)
    return ( 
        <footer className="mastfoot mt-5 text-center">
            <div className="inner">
                <p className={css.text}>COPYRIGHT &copy; {new Date().getFullYear()} {t.copyright.alr[i18n.language]}</p>
            </div>
        </footer>
     );
}

export default Footer;